// operatoriSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  operatori: [],
  singleOperatori: {},
  isLoading: false,
  error: null,
};

const operatoriSlice = createSlice({
  name: "operatoriData",
  initialState,
  reducers: {
    setOperatori: (state, action) => {
      state.operatori = action.payload;
    },
    addOperatori: (state, action) => {
      if (action.payload) {
        if (!Array.isArray(state.operatori)) {
          state.operatori = [];
        }
        state.operatori.push(action.payload);
      }
    },
    addOperatoriId: (state, action) => {
      state.singleOperatori = action.payload;
    },
    updateOperatori: (state, action) => {
      const index = state.operatori.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.operatori[index] = action.payload;
      }
    },
    deleteOperatori: (state, action) => {
      state.operatori = state.operatori.filter(
        (item) => item.id !== action.payload
      );
    },
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setOperatori,
  addOperatori,
  addOperatoriId,
  updateOperatori,
  deleteOperatori,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
} = operatoriSlice.actions;

export const selectOperatori = (state) => state.operatori?.operatori;
export const selectSingleOperatori = (state) => state.operatori?.singleOperatori;
export const selectIsLoading = (state) => state.operatori?.isLoading;
export const selectError = (state) => state.operatori?.error;

export default operatoriSlice.reducer;